<template>
    <div>
        <van-nav-bar
            title="请选择注册类型"
            left-text="返回"
            left-arrow
            @click-left="$router.push({path:'/'})"

        />
        
        <div class="dialog-register">
            <div class="dialog-register-item col-12" :class="{'active':switchNum == item.formData}" v-for="(item,index) in registerData" :key="index" @click="switchForm(item.formData)"> 
                <div class="register-item-tab"><i :class="item.icon"></i></div>
                <div class="register-item-title">{{ item.title }}</div>
                <div class="register-item-desc">{{ item.desc }}</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            switchNum:0,
            registerData:[
                {
                    icon:"el-icon-s-home",
                    title:"资源用户",
                    desc:"适用于提供资源的企业用户",
                    formData:'1'
                },{
                    icon:"el-icon-user-solid",
                    title:"个人用户",
                    desc:"适用于个人需求用户注册",
                    formData:'2'
                },{
                    icon:"el-icon-s-cooperation",
                    title:"企业用户",
                    desc:"适用于企业需求用户注册",
                    formData:'3'
                },
            ]
            
        };
    },
    methods: {
        switchForm(tab) {
            this.switchNum = tab; 
            this.$router.push({path:'/mobileRegisterForm'+tab})

        },
    },
};
</script>
<style lang="scss" scoped>

.dialog-register{
    width:100%;
    height:auto;
    // margin:10px auto 10px;
    cursor:default;
    // background-color: #f7f7f7;
    .dialog-register-item{
        width:90%;
        height:150px;
        border:1px solid #E5E7EB;
        border-radius:10px;
        text-align:center;
        box-sizing:border-box;
        padding:10px 0;
        margin:10px auto;
        transition: transform 0.2s ease-in-out;
        .register-item-tab{
            width:50px;
            height:50px;
            margin:0 auto;
            border-radius:50%;
            color:#0066ff;
            font-size:22px;
            background-color: #dbeafe;
            display:flex;
            align-items: center;
            justify-content: center;
        }
        .register-item-title{
            font-size:15px;
            color:#333;
            margin-top:10px;
        }
        .register-item-desc{
            font-size:13px;
            color:#666;
            margin-top:10px;
        }
    }
    // .dialog-register-item:hover{
    //     transform: translateY(-8px);
    //     .register-item-title{
    //         color:#0066ff;
    //     }
    //     .register-item-desc{
    //         color:#0066ff;
    //     }
    // }
    // .dialog-register-item.active{
    //     border:2px solid #3B82F6;
    //     background-color:#eff6ff;
    // }
}
</style>
